import { useMemo } from "react";

import useAccessibleColors from "@/utils/hooks/useAccessibleColors";

export const ANSWERED = "Answered";
export const ELSEWHERE = "Answered elsewhere";
export const REJECTED = "Rejected";
export const ABANDONED = "Abandoned";

export const seriesOrder = [ANSWERED, ELSEWHERE, REJECTED, ABANDONED];

export function useSeriesColors() {
  const { green, lime, amber, red } = useAccessibleColors();

  return useMemo(() => [green, lime, amber, red], [green, lime, amber, red]);
}
